export const tokenService = {
  getAccessToken() {
    return localStorage.getItem("TW_access_token");
  },
  getRefreshToken() {
    return localStorage.getItem("TW_refresh_token");
  },
  setTokens({
    accessToken,
    refreshToken,
  }: {
    accessToken: string;
    refreshToken: string;
  }) {
    localStorage.setItem("TW_access_token", accessToken);
    localStorage.setItem("TW_refresh_token", refreshToken);
  },
  clear() {
    localStorage.removeItem("TW_access_token");
    localStorage.removeItem("TW_refresh_token");
  },
};
